import { MemberAuditTab } from "@/components/members/detail/member-audit-tab.tsx";
import { PlanGate } from "@/components/plan-gate.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/settings/org/members/$userId/audit",
)({
	component: RouteComponent,
});

/**
 * Plan-gated, exactly as `/settings/audit-logs` is. Audit history is a paid feature and
 * that page gates on the plan rather than on admin; an ungated second door from an admin
 * surface would hand it to every free-tier org, since every org has an admin. Same
 * `requiredPlan` and the same copy, so the two doors cannot drift apart on price.
 */
function RouteComponent() {
	return (
		<PlanGate
			requiredPlan="starter"
			featureName={m.plan_gate_feature_audit_logs()}
			description={m.plan_gate_desc_audit_logs()}
			benefits={[
				m.plan_gate_benefit_audit_history(),
				m.plan_gate_benefit_audit_retention(),
				m.plan_gate_benefit_audit_filter(),
			]}
			// Inside a tab, not a page: the full-page upsell would dwarf the tab strip.
			variant="lightweight"
		>
			<MemberAuditTab />
		</PlanGate>
	);
}
